import { render, staticRenderFns } from "./SpeakerEditTabInformation.vue?vue&type=template&id=38f6467b&"
import script from "./SpeakerEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./SpeakerEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports